export const EInsPolicyStatus = {
   "-1": "ALL",
   0: "UNKNOWN",
   1: "NEW",
   2: "RESERVED",
   3: "BOOKED",
   4: "CANCELED",
   5: "VOIDED",
   6: "REFUNDED",
   7: "REBOOKED",
   8: "ERROR",
   10: "PENDING_BOOKED",
   11: "PENDING_RESERVED",
   12: "PENDING_CANCELED",
   13: "PENDING_VOIDED",
   14: "PENDING_REFUNDED",
};

export const EInsPolicyPriceStatus = {
   "-1": "ALL",
   0: "UNKNOWN",
   1: "NEW",
   2: "RESERVED",
   3: "BOOKED",
   4: "CANCELED",
   5: "VOIDED",
   6: "REFUNDED",
   7: "REBOOKED",
   8: "ERROR",
   10: "PENDING_BOOKED",
   11: "PENDING_RESERVED",
   12: "PENDING_CANCELED",
   13: "PENDING_VOIDED",
   14: "PENDING_REFUNDED",
};

export const EInsImportType = {
   "-1": "ALL",
   0: "UNKNOWN",
   1: "AUTO",
   2: "MANUAL",
};

export const EInsPolicyPriceType = {
   "-1": "ALL",
   0: "UNKNOWN",
   1: "ENTITY_BASE",
   2: "PAX_BASE",
};
